export const useLocation = () => {
  const location = window.location.pathname;

  return location;
};
